import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'

Vue.config.productionTip = false

axios.defaults.withCredentials = true

axios.interceptors.response.use((response) => {
  return response
}, function (err) {
  if (err.response && err.response.data === 'NotLoggedIn') {
    router.push('/login')
  }

  return Promise.reject(err)
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
